/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  SitemapControllerGetSitemapManifestQueryResponse,
  SitemapControllerGetSitemapManifestHeaderParams,
  SitemapControllerGetSitemapManifest404,
  SitemapControllerGetSitemapManifest503,
} from '../types/SitemapControllerGetSitemapManifest.ts';

function getSitemapGetSitemapManifestUrl() {
  const res = { method: 'GET', url: `/api/sitemap/manifest` as const };
  return res;
}

/**
 * @summary Get the published sitemap manifest for the current website.
 * {@link /api/sitemap/manifest}
 */
export async function sitemapGetSitemapManifest(
  headers?: SitemapControllerGetSitemapManifestHeaderParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    SitemapControllerGetSitemapManifestQueryResponse,
    ResponseErrorConfig<SitemapControllerGetSitemapManifest404 | SitemapControllerGetSitemapManifest503>,
    unknown
  >({
    method: 'GET',
    url: getSitemapGetSitemapManifestUrl().url.toString(),
    ...requestConfig,
    headers: { ...headers, ...requestConfig.headers },
  });
  return res.data;
}
